import { ArrowUpRight } from "lucide-react";

const button =
  "flex items-center justify-center gap-2 w-full py-3.5 rounded-xl bg-linear-to-r/srgb from-teal-500 to-cyan-600 text-white font-medium hover:brightness-110 transition-[filter]";

const Portal = () => (
  <section className="relative min-h-screen pt-32 pb-24">
    <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-white mb-4">Customer Portal</h1>
      <p className="text-xl text-gray-400 mb-12">Sign in to your account or open your company's tools.</p>

      <div className="grid gap-4">
        <div className="p-6 rounded-2xl glass border-teal-500/30">
          <h2 className="text-xl font-medium text-white mb-1">Website Owners</h2>
          <p className="text-gray-400 text-sm mb-3">Your RareWorks website</p>
          <p className="text-gray-400 leading-relaxed mb-5">
            For anyone with a RareWorks website or account. Request changes, update your business info, pick a web
            address, and manage billing.
          </p>
          <a href="https://leads.rare-works.com/account/" className={button}>
            Owner Sign In
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="p-6 rounded-2xl glass">
          <div className="flex items-center gap-4 mb-3">
            <img src="/skeulur_logo.webp" alt="" className="w-12 h-12 rounded-xl object-cover" />
            <div>
              <h2 className="text-xl font-medium text-white">Skeulur</h2>
              <p className="text-gray-400 text-sm">Employee scheduling</p>
            </div>
          </div>
          <p className="text-gray-400 leading-relaxed mb-5">
            Work schedule management, time-off requests, shift swaps, and team coordination.
          </p>
          <a href="https://skeulur1.rare-works.com" target="_blank" rel="noopener noreferrer" className={button}>
            Open App
            <ArrowUpRight className="w-4 h-4" />
          </a>
          <a
            href="/skeulur-status.html"
            className="block text-center mt-4 text-sm text-gray-400 hover:text-white underline underline-offset-2"
          >
            System status
          </a>
        </div>
      </div>

      <p className="mt-8 text-center text-gray-400 text-sm">
        On the RareWorks sales team?{" "}
        <a href="https://leads.rare-works.com/rep/" className="text-teal-400 hover:text-teal-300 underline underline-offset-2">
          Rep sign in
        </a>
      </p>
    </div>
  </section>
);

export default Portal;
